<svg xmlns="http://www.w3.org/2000/svg" width="57.074" height="40.05" viewBox="0 0 57.074 40.05">
    <g id="Icon_feather-menu" data-name="Icon feather-menu" transform="translate(3 3)">
        <path
            id="Pfad_12"
            data-name="Pfad 12"
            d="M55.574,21H4.5a3,3,0,1,1,0-6H55.574a3,3,0,1,1,0,6Z"
            transform="translate(-4.5 -0.975)"
            fill="#fff"
        />
        <path
            id="Pfad_13"
            data-name="Pfad 13"
            d="M55.574,12H4.5a3,3,0,1,1,0-6H55.574a3,3,0,1,1,0,6Z"
            transform="translate(-4.5 -9)"
            fill="#fff"
        />
        <path
            id="Pfad_14"
            data-name="Pfad 14"
            d="M55.574,30H4.5a3,3,0,1,1,0-6H55.574a3,3,0,1,1,0,6Z"
            transform="translate(-4.5 7.05)"
            fill="#fff"
        />
    </g>
</svg>
